export const AppetiteModel = {
  Default: 'default',
  TopDownCascade: 'top_down_cascade',
} as const;

export type AppetiteModel = (typeof AppetiteModel)[keyof typeof AppetiteModel];
